<script setup>
import { useI18n } from 'vue-i18n'
import LicenceExpiryPill from '@/Components/UI/LicenceExpiryPill.vue'

defineProps({ customer: { type: Object, required: true } })

const { t } = useI18n()
</script>

<template>
  <div class="space-y-2">
    <!-- Top row: name + rentals count -->
    <div class="flex items-start justify-between gap-3">
      <div class="min-w-0 flex-1">
        <div class="truncate text-[color:var(--ink)] font-medium">
          {{ customer.full_name || `${customer.first_name || ''} ${customer.last_name || ''}`.trim() || t('customers.card.unknown') }}
        </div>
        <a
          v-if="customer.phone"
          :href="`tel:${customer.phone}`"
          class="text-xs text-[color:var(--inkSoft)] tabular-nums"
          @click.stop
        >{{ customer.phone }}</a>
      </div>
      <div
        v-if="customer.rentals_count != null"
        class="shrink-0 text-right"
      >
        <div class="fw-value tabular-nums text-[color:var(--ink)]">
          {{ customer.rentals_count }}
        </div>
        <div class="mt-0.5 text-[10px] uppercase tracking-wide text-[color:var(--muted)]">
          {{ t('customers.card.rentals') }}
        </div>
      </div>
    </div>

    <!-- Email + licence -->
    <div class="flex items-center justify-between gap-3 text-xs">
      <span class="min-w-0 truncate text-[color:var(--muted)]">{{ customer.email || '—' }}</span>
      <div class="flex items-center gap-2 shrink-0">
        <span
          v-if="customer.preferred_locale"
          class="inline-flex items-center px-1.5 py-0.5 rounded-full text-[10px] font-semibold tracking-wider"
          :style="{ background: 'var(--surfaceAlt)', color: 'var(--inkSoft)', border: '1px solid var(--line)' }"
        >
          {{ customer.preferred_locale.toUpperCase() }}
        </span>
        <LicenceExpiryPill
          v-if="customer.licence_expiry"
          :expires-at="customer.licence_expiry"
        />
      </div>
    </div>
  </div>
</template>
